<template>
  <v-container class="px-0 pb-8 pt-0">
      <v-row class="mr-10 px-0">
        <v-col class="py-1" cols="12" sm="4" md="4">
          <h2 class="texts">Arquivo:</h2>
          <v-card flat>
            <p class="texts mb-0">{{info.arq_nome}}</p>
          </v-card>
        </v-col>
        <v-col class="py-1" cols="12" sm="4" md="3">
          <h2 class="texts">Número do lote:</h2>
          <p class="texts mb-0">{{info.arq_numero_lote}}</p>
        </v-col>
        <v-col class="py-1" cols="12" sm="4" md="3">
          <h2 class="texts">Tipo de guia:</h2>
          <p class="texts mb-0">{{info.descricao}}</p>
        </v-col>
        <v-col class="py-1" cols="12" sm="4" md="2">
          <h2 class="texts">Número de guias:</h2>
          <p class="texts mb-0">{{info.arq_qtd_guias}}</p>
        </v-col>
        <v-col class="py-1" cols="12" sm="4" md="4">
          <h2 class="texts">Prestador:</h2>
          <p class="texts mb-0">{{info.prest_nome}}</p>
        </v-col>
        <v-col class="py-1" cols="12" sm="4" md="3">
          <h2 class="texts">Operadora:</h2>
          <p class="texts mb-0">{{info.oper_nome}}</p>
        </v-col>
        
        <v-col class="py-1" cols="12" sm="4" md="3">
          <h2 class="texts">Valor informado (R$):</h2>
          <p class="texts mb-0">{{info.arq_vl_informado | formatPrice}}</p>
        </v-col>
        <v-col class="py-1" cols="12" sm="4" md="2">
          <h2 class="texts">Importação:</h2>
          <p class="texts mb-0">{{info.upload_dt | formatData}}</p>
        </v-col>
        <v-col class="py-1" cols="12" sm="4" md="4">
          <h2 class="texts">Identificação prest.:</h2>
          <p class="texts mb-0">{{info.arq_identificador_prestador}}</p>
        </v-col>
        <v-col class="py-1" cols="12" sm="4" md="3">
          <h2 class="texts">Registro ANS:</h2>
          <p class="texts mb-0">{{info.operadora_ans_id}}</p>
        </v-col>
        <v-col class="py-1" cols="12" sm="4" md="3">
          <h2 class="texts">Valor calculado (R$):</h2>
          <p class="texts mb-0">{{info.arq_vl_calculado | formatPrice}}</p>
        </v-col>
         <v-col class="py-1" cols="12" sm="4" md="2">
          <h2 class="texts">Transmissão:</h2>
          <p class="texts mb-0">{{info.env_op_dt | formatData}}</p>
        </v-col>
      </v-row>
    </v-container>
</template>

<script>
import moment from 'moment'
export default {
  data() {
    return {
      showOpen: null
    }
  },
  filters:{
    formatData(date){
      return  moment(date).format('DD/MM/YYYY')
    },
    formatPrice(value) {
        let val = (value/1).toFixed(2).replace('.', ',')
        return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    }
  },
  props: {
    info: Object,
  }
}
</script>

<style>
.texts {
  color: #4a4a4a;
  font-size: 14px;
  line-height: 23px;
}
.ematraso {
  color: #FC9D0A;
  font-weight: bold;
}
</style>